<template>
  <div class="tool-card-wrapper">
    <template v-for="(item, index) in config">
      <div class="tools-item" :key="index" @click="onClick(index, item)">
        <img :src="item.coverImage" alt="示意图">
        <div class="float">
          <div class="title">{{item.title}}</div>
          <div class="subtitle">{{item.subtitle}}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "Tools",
  props: {
    config: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClick(index, item) {
      this.$emit("click", index, item)
    }
  }
}
</script>

<style scoped lang="scss">
.tool-card-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 160px);
  grid-template-rows: 181px;
  gap: 9px 26px;

}
.tools-item{
  position: relative;
  img{
    width: 100%;
  }
}
.float {
  padding: 0 12px;
  top: 105px;
  position: absolute;
  left: 0;
  right: 0;
}
.title{
  font-size: 23.76px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 31.51px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}
.subtitle {
  font-size: 14.85px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 19.69px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}
</style>